import { memo, useRef } from "react"
import { useDrag, useDrop } from "react-dnd"

const DraggableRow = memo(function DraggableRow({ id, index, moveRow, children }) {
    const ref = useRef(null)
  
    const [, drop] = useDrop({
      accept: "row",
      hover(item, _) {
        if (!ref.current) return
        const dragIndex = item.index
        const hoverIndex = index
        if (dragIndex === hoverIndex) return
        moveRow(dragIndex, hoverIndex)
        item.index = hoverIndex
      },
    })
  
    const [{ isDragging }, drag] = useDrag({
      type: "row",
      item: { id, index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    })
  
    drag(drop(ref))
  
    return (
      <tr ref={ref} style={{ opacity: isDragging ? 0.4 : 1 }}>
        {children}
      </tr>
    )
  })
  
export default DraggableRow